'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styles$6 = require('./styles-6fa8f6cf.js');

var StatusPill = function (_a) {
    var status = _a.status, color = _a.color, className = _a.className, _b = _a.variant, variant = _b === void 0 ? constants.STATUS_PILL_VARIANT.SQUARED : _b, displayText = _a.displayText;
    return (React__default.createElement(styles$6.Container, { className: className },
        React__default.createElement(styles$6.StyledStatusPill, { variant: variant, status: status, color: color, "data-testid": "status-pill", className: "status-pill" }, displayText !== null && displayText !== void 0 ? displayText : status)));
};

exports.StatusPill = StatusPill;
